import React from "react";

const Instrucoes = () => {
  return (
    <>
      <div className="  pb-8 mt-6 simulators__content">
        <h3 className="text-2xl font-bold text-center max-w-[470px] mx-auto mt-12">
          Siga o passo a passo a baixo para realizar a primeira simulação do cliente:
        </h3>
        <div className="max-w-[700px] mx-auto mt-12 flex flex-col simulators__step">
          <div className="self-start">
            <h4 className="text-xl font-bold mb-2">Passo 01</h4>
            <p className="">
              Adicione os produtos, aplicando as condições comerciais (regra, faixa ou condição especial) e serviços
              (descarga, fracionamento) que deseja simular na negociação para o cliente;
            </p>
          </div>
          <div className="">
            <h4 className="text-xl font-bold mb-2">Passo 02</h4>
            <p className="">
              Ao enviar a simulação para o cliente, não esqueça de enviar as negociações (faixa ou condição especial)
              para o fluxo de aprovação conforme alçada correspondente.
            </p>
          </div>
          <div className=" self-start ">
            <h4 className="text-xl font-bold mb-2">Passo 03</h4>
            <p className="">
              Após a adição dos produtos, você pode salvar/baixar a simulação e enviar o arquivo em PDF para o cliente.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Instrucoes;
